export class Procedure {

  procedureCode: number;
  procedureType: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
